/**
 * @author Domenico de Felice 2018-02-14 - Card 1226 - additional fields in Eligibility "appeal" disputes.
 */
'use strict';
var DetailEligibilityGoeAppealController = (function () {
    function DetailEligibilityGoeAppealController(topic, $scope, socket) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.socket = socket;
        this.comp = 'goe_appeal'; // Name of this component
        this.appealRequestReceived = undefined;
        this.appealRequestSentToSecondReview = undefined;
        this.appealValidityInformation = ''; // default value
        this.appealStage = ''; // default value
        // this is set to true only for DMT dispute documents flagged as 'appeal'
        if (topic.topic.dispute_details) {
            if (topic.topic.dispute_details.dispute_type) {
                //console.log("Dispute details: " + topic.topic.dispute_details.dispute_type);
                if (topic.topic.dispute_details.dispute_type === 'Appeal') {
                    // set subform visible
                    this.visibleGOEAppealSection = true; // set subform visible
                    //console.log("GOE Appeal section visible: " + this.visibleGOEAppealSection);
                    // Field: appeal request received
                    topic.topic.goe_appeal && topic.topic.goe_appeal.appealRequestReceived ?
                        this.appealRequestReceived = new Date(parseInt(topic.topic.goe_appeal.appealRequestReceived, 10)) :
                        this.appealRequestReceived;
                    //console.log("Appeal request received: " + this.appealRequestReceived);
                    // Field: Appeal validity information
                    topic.topic.goe_appeal && topic.topic.goe_appeal.appealValidityInformation ?
                        this.appealValidityInformation = topic.topic.goe_appeal.appealValidityInformation :
                        this.appealValidityInformation;
                    //console.log("Appeal validity info: " + this.appealValidityInformation);
                    // Field: Appeal Stage
                    topic.topic.goe_appeal && topic.topic.goe_appeal.appealStage ?
                        this.appealStage = topic.topic.goe_appeal.appealStage :
                        this.appealStage;
                    //console.log("Appeal request stage: " + this.appealStage);
                    // Field: Appeal request sent to second review
                    topic.topic.goe_appeal && topic.topic.goe_appeal.appealRequestSentToSecondReview ?
                        this.appealRequestSentToSecondReview = new Date(parseInt(topic.topic.goe_appeal.appealRequestSentToSecondReview, 10)) :
                        this.appealRequestSentToSecondReview;
                }
            }
        }
        // options for dropdown menu Appeal Stage
        this.appealStageOptions = ['appeal on hold',
            'appeal approved',
            'appeal declined',
            'appeal rejected',
            'second review',
            'second review on hold',
            'review approved',
            'review declined',
            'review rejected'];
        this.appealValidityOptions = ['Valid', 'Invalid'];
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            // If the topic has been updated from the server...check if this component is part of
            // what was changed
            if (data.indexOf(_this.comp) > -1) {
                // If so, set edit status accordingly...
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
    }
    DetailEligibilityGoeAppealController.prototype.toggleGOEAppealFields = function () {
        this.visibleGOEAppealFields = !this.visibleGOEAppealFields;
    };
    DetailEligibilityGoeAppealController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp); // Set edit based on value in topic.editableComponents
    };
    /**
     * Default function for all components that use the 10k edit/save/cancel component
     * @param action
     */
    DetailEligibilityGoeAppealController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            // Set the status of this component to Updating...
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                // Prepare data to be saved
                var updateObject = {
                    data: {
                        goe_appeal: {
                            add: true,
                            data: this.topic.temp.goe_appeal
                        }
                    },
                    id: this.topic.topic._id,
                    type: ['goe_appeal']
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true); // Send it to be saved
                this.edit.editMode = this.topic.cancelEdit(this.comp); // Turn edit off
            }
        }
        else if (action === 'edit') {
            // Set temp values in topic for invoice_flags - and set edit mode to editable
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp); // Set status uneditable
        }
    };
    DetailEligibilityGoeAppealController.$inject = ['topic', '$scope', 'socket']; // Minimum required
    return DetailEligibilityGoeAppealController;
}());
var DetailEligibilityGoeAppealComponent = (function () {
    function DetailEligibilityGoeAppealComponent() {
        this.templateUrl = 'detail-eligibility-goe-appeal.html';
        this.controllerAs = 'vm';
        this.controller = DetailEligibilityGoeAppealController;
    }
    return DetailEligibilityGoeAppealComponent;
}());
// const angular: any = undefined;
angular
    .module('application')
    .component('detailEligibilityGoeAppeal', new DetailEligibilityGoeAppealComponent());

//# sourceMappingURL=detail.eligibility.goe.appeal.component.js.map
